document.addEventListener("DOMContentLoaded", () => {
  const spinSlides = document.querySelectorAll("[data-spin-slide]");

  spinSlides.forEach((spinSlide) => {
    const spinBox = spinSlide.querySelector("[data-spin-prefix]");
    const spinImg = spinSlide.querySelector("img");

    if (!spinBox || !spinImg) return;

    const prefix = (spinBox.dataset.spinPrefix || "").trim();
    if (!prefix) return;

    const totalFrames = 24;
    let frame = 1;
    let isDragging = false;
    let startX = 0;
    let accumulatedDelta = 0;
    const threshold = 20; // plus haut = moins sensible

    function getFrame(n) {
      return `https://cdn.shopify.com/s/files/1/0748/6983/3950/files/${prefix}${String(n).padStart(4, "0")}.png`;
    }

    function setFrame(n) {
      frame = n;
      spinImg.src = getFrame(frame);
    }

    function nextFrame(direction) {
      frame += direction;

      if (frame < 1) frame = totalFrames;
      if (frame > totalFrames) frame = 1;

      setFrame(frame);
    }

    setFrame(1);

    spinBox.style.cursor = "grab";
    spinBox.style.userSelect = "none";
    spinBox.style.webkitUserSelect = "none";
    spinBox.style.touchAction = "pan-y";

    spinBox.addEventListener("dragstart", (e) => e.preventDefault());

    spinBox.addEventListener("mousedown", (e) => {
      isDragging = true;
      startX = e.clientX;
      accumulatedDelta = 0;
      spinBox.style.cursor = "grabbing";
      e.preventDefault();
    });

    document.addEventListener("mouseup", () => {
      isDragging = false;
      accumulatedDelta = 0;
      spinBox.style.cursor = "grab";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDragging) return;

      const delta = e.clientX - startX;
      startX = e.clientX;
      accumulatedDelta += delta;

      if (Math.abs(accumulatedDelta) >= threshold) {
        const steps = Math.floor(Math.abs(accumulatedDelta) / threshold);
        const direction = accumulatedDelta > 0 ? -1 : 1; // inverse si tu veux l'autre sens

        for (let i = 0; i < steps; i++) {
          nextFrame(direction);
        }

        accumulatedDelta = accumulatedDelta % threshold;
      }

      e.preventDefault();
    });

    spinBox.addEventListener(
      "touchstart",
      (e) => {
        if (!e.touches.length) return;
        isDragging = true;
        startX = e.touches[0].clientX;
        accumulatedDelta = 0;
      },
      { passive: true }
    );

    spinBox.addEventListener(
      "touchmove",
      (e) => {
        if (!isDragging || !e.touches.length) return;

        const delta = e.touches[0].clientX - startX;
        startX = e.touches[0].clientX;
        accumulatedDelta += delta;

        if (Math.abs(accumulatedDelta) >= threshold) {
          const steps = Math.floor(Math.abs(accumulatedDelta) / threshold);
          const direction = accumulatedDelta > 0 ? -1 : 1; // inverse si tu veux l'autre sens

          for (let i = 0; i < steps; i++) {
            nextFrame(direction);
          }

          accumulatedDelta = accumulatedDelta % threshold;
        }
      },
      { passive: true }
    );

    spinBox.addEventListener("touchend", () => {
      isDragging = false;
      accumulatedDelta = 0;
    });
  });
});